/** Form 45 (2026) — docx [[if …]] 분기용 헬퍼 */

const PASSPORT_ID_TYPE_CODES = new Set(['B03004', 'B22004']);

export function isSgPassportIdType(idTypeCd: unknown): boolean {
  const cd = String(idTypeCd ?? '').trim().toUpperCase();
  return PASSPORT_ID_TYPE_CODES.has(cd);
}

export function resolveForm45UsesPassport(input: {
  directorIdTypeCd?: unknown;
  idTypeLabel?: unknown;
}): boolean {
  if (isSgPassportIdType(input.directorIdTypeCd)) return true;
  return /passport/i.test(String(input.idTypeLabel ?? '').trim());
}

export function toForm45ConditionalFlag(value: unknown): boolean {
  if (value === true || value === 1) return true;
  const s = String(value ?? '').trim().toLowerCase();
  return s === 'yes' || s === 'true' || s === '1' || s === 'y';
}
